var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.items.length > 4)?_c('div',[_c('NewsGrid',{attrs:{"items":_vm.items,"item-type":"Alfa"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }